import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import './ResourceViewForm.css';
import { Allassetcategory, getAllRole, getassetsubcategory, rolebaseuser, stafftype } from "../../../../Services/EndPoints";
import { getData, postDataWithBody } from "../../../../Services/Services";
import { format, parse } from 'date-fns';

// A React functional component that displays detailed information about a resource request
const ResourceViewForm = () => {
    const location = useLocation();
    const { data, bank, branch, } = location.state || {};
    const [assetcategory1, setassetcategory] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [staffTypes, setStaffTypes] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [allrole, setAllRole] = useState([])

    // useEffect hook to fetch data when component mounts or when data changes
    useEffect(() => {
        if (data?.asset_resource?.length > 0) {
            fetchcategory();
            fetchSubCategories(data.asset_resource[0].assetCategoryId); // Only once
        }
        fetchUsersByRole(data.assigned_team)
        fetchstaffdetails()
        fetchRole()
    }, [data]);

    // Fetches all roles from the API and updates the state
    const fetchRole = async () => {
        try {
            const response = await getData(getAllRole);
            if (Array.isArray(response)) setAllRole(response);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    // Fetches users based on a specific role ID
    const fetchUsersByRole = async (roleId) => {
        try {
            const response = await getData(rolebaseuser.replace("ID", roleId));
            if (Array.isArray(response)) setAssignedUsers(response);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    // Fetches staff type details from the API
    const fetchstaffdetails = async () => {
        try {
            let request = ["STAFF_CAT"]
            const response = await postDataWithBody(stafftype, request, {})
            if (Array.isArray(response)) {
                setStaffTypes(response);
            }
        } catch (error) {
            console.error("Error fetching staff details:", error);
        }
    }

    // Fetches asset categories from the API
    const fetchcategory = async () => {
        try {
            let request = ["ASSET_CAT"]
            const response = await postDataWithBody(Allassetcategory, request, {})
            if (response && Array.isArray(response)) {
                setassetcategory(response);
            }
        } catch (error) {
            console.error("Error fetching asset categories:", error);
        }
    }

    // Fetches subcategories for a given category ID
    const fetchSubCategories = async (categoryId) => {
        try {
            const response = await getData(getassetsubcategory.replace("ID", categoryId));
            if (Array.isArray(response)) {
                setSubCategories(response);
            }
        } catch (error) {
            console.error("Error fetching subcategories", error);
        }
    };

    // Gets the category name by its ID
    const getCategoryName = (id) => {
        const category = assetcategory1.find(cat => cat.id === id);
        return category ? category.value : 'NA';
    };

    // Gets the user name by their ID
    const getUserNameById = (id) => {
        const user = assignedUsers.find(user => user.id === id);
        return user?.user_name || 'N/A';
    };

    // Gets the subcategory name by its ID
    const getSubCategoryName = (id) => {
        const subCategory = subCategories.find(sub => sub.id === id);
        return subCategory ? subCategory.value : 'NA';
    };

    // Gets the staff name by their ID
    const getStaffNameById = (id) => {
        const staff = staffTypes.find(item => item.id === id);
        return staff?.value || 'NA';
    };

    return (
        <>
            <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
                <div className="row g-0" style={{ minHeight: "75vh", overflow: "hidden" }}>
                    {/* Left Panel */}
                    <div className="col-md-12 p-4 bg-white">
                        <div className="grid-4-col">
                            <div className="field">
                                <span className="label">Request ID</span>
                                <span className="value">{data?.resourceId || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label"> Resource Title</span>
                                <span className="value" style={{
                                    marginBottom: '15px',
                                    whiteSpace: 'pre-wrap',  // Preserves line breaks and wraps text
                                    wordBreak: 'break-word', // Ensures long words break and wrap
                                    display: 'block',        // Makes it a block element
                                    width: '100%'            // Takes full width available
                                }}>{data?.jobTitle || 'NA'}</span>
                            </div>

                            <div className="field">
                                <span className="label">Request Type</span>
                                <span className="value">{data?.requestType || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Requested Date & Time</span>
                                <span className="value">
                                    {data?.requestDateAndTime
                                        ? format(
                                            parse(data.requestDateAndTime, 'yyyy-MM-dd HH:mm:ss.S', new Date()),
                                            'dd-MM-yyyy hh:mm a'
                                        )
                                        : 'NA'}
                                </span>
                            </div>

                            <div className="field">
                                <span className="label">Reqested By Department</span>
                                <span className="value">{data?.reqByDepartment || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Requestor Name</span>
                                <span className="value">{data?.requestorName || 'NA'}</span>
                            </div>

                            <div className="field">
                                <span className="label">Bank Name</span>
                                <span className="value">{bank?.bankName || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Branch Name</span>
                                <span className="value">{branch?.branchName || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Email</span>
                                <span className="value">{data?.email || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Contact Number</span>
                                <span className="value">{data?.phoneNumber || 'NA'}</span>
                            </div>
                            <div className="field">
                                <span className="label">Assigned Team</span>
                                <span className="value">{allrole.find(role => String(role.id) === String(data?.assigned_team))?.name || 'NA'}</span>
                            </div>
                        </div>
                        <div className="field">
                            <span className="label"> Resource Description</span>
                            <span className="value" style={{
                                marginBottom: '15px',
                                whiteSpace: 'pre-wrap',  // Preserves line breaks and wraps text
                                wordBreak: 'break-word', // Ensures long words break and wrap
                                display: 'block',        // Makes it a block element
                                width: '100%'            // Takes full width available
                            }}>{data?.description || 'NA'}</span>
                        </div>
                        {data.asset_resource?.length > 0 && (
                            <>
                                <h5 style={{ textDecoration: "underline", fontFamily: 'Poppins', fontSize: '15px', fontWeight: '500', color: '#ff9800' }}>Asset Details</h5>
                                <div className="grid-4-col">
                                    {data.asset_resource.map((asset, index) => (
                                        <React.Fragment key={index}>
                                            <div className="field">
                                                <span className="label">Asset Name</span>
                                                <span className="value">{asset.assetName || 'NA'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Asset Category</span>
                                                <span className="value">{getCategoryName(asset.assetCategoryId)}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Asset Type</span>
                                                <span className="value">{getSubCategoryName(asset.assetTypeId)}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Assigned To</span>
                                                <span className="value">{getUserNameById(asset.assignedTo) || 'NA'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Quantity Required</span>
                                                <span className="value">{asset.quantity || '0'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Non-Functional Units</span>
                                                <span className="value">{asset.nonFunctionalUnits || '0'}</span>
                                            </div>
                                            <div className="field" style={{ gridColumn: "1 / -1" }}>
                                                <span className="label">Action Message</span>
                                                <span className="value" style={{
                                                    whiteSpace: 'pre-wrap',
                                                    wordBreak: 'break-word',
                                                    display: 'block',
                                                    width: '100%'
                                                }}>{asset.actionMessage || 'NA'}</span>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}

                        {data.staff_resource?.length > 0 && (
                            <>
                                <h5 style={{ textDecoration: "underline", fontFamily: 'Poppins', fontSize: '15px', fontWeight: '500', color: '#ff9800' }}>Staff Details</h5>
                                <div className="grid-4-col">
                                    {data.staff_resource.map((staff, index) => (
                                        <React.Fragment key={index}>
                                            <div className="field">
                                                <span className="label">Staff Type</span>
                                                <span className="value">{getStaffNameById(staff.staffId)}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Employment Type</span>
                                                <span className="value">{staff.employmentType || 'NA'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Experience Level</span>
                                                <span className="value">{staff.expLevel || 'NA'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Assigned To</span>
                                                <span className="value">{getUserNameById(staff.assignedTo) || 'NA'}</span>
                                            </div>

                                            <div className="field" style={{ gridColumn: "1 / -1" }}>  {/* Make this field span all columns */}
                                                <span className="label">Required Skill Set</span>
                                                <span className="value" style={{
                                                    whiteSpace: 'pre-wrap',
                                                    wordBreak: 'break-word',
                                                    display: 'block',
                                                    width: '100%'
                                                }}>{staff.skills || 'NA'}</span>
                                            </div>
                                            <div className="field">
                                                <span className="label">Action Message</span>
                                                <span className="value" style={{
                                                    whiteSpace: 'pre-wrap',
                                                    wordBreak: 'break-word',
                                                    display: 'block',
                                                    width: '420%'
                                                }} >{staff.actionMessage || 'NA'}</span>
                                            </div>

                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </div>
        </>
    );
};

export default ResourceViewForm;